import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LivAllertaLegenda } from './livAllertaLegenda.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [LivAllertaLegenda],
  imports: [
    CommonModule,
    NgbModule,
  ],
  exports: [LivAllertaLegenda]
})
export class LivAllertaLegendaModule { }
